/**
 * TBD
 */ export var OPEN_WITH_FAIRE_OFFERED_TERMS = 'OPEN_WITH_FAIRE_OFFERED_TERMS';
